import { constants } from '@eti/utils';
import { useEffect } from 'react';
import { useSiteContext } from '@eti/providers';
import { useScript } from '../common/custom-hooks/useScript';

declare global {
  interface Window {
    STJR: { setConfig: (config: Record<string, unknown>) => void };
  }
}

const {
  brands: { MYTRIP, GOTOGATE, FLIGHTNETWORK },
} = constants;

const sitejabberIds = {
  [FLIGHTNETWORK]: '5318e51f52576',
  [GOTOGATE]: '5d4cb7f6d3c20',
  [MYTRIP]: '592d7fe170224',
} as const;

const hasSitejabberId = (brand: string): brand is keyof typeof sitejabberIds =>
  Object.prototype.hasOwnProperty.call(sitejabberIds, brand);

interface SitejabberProps {
  email: string;
  name: string;
  orderNumber: string;
  phone: string;
  purchaseDate: string;
  language: string;
}

const Sitejabber = ({
  email,
  name,
  orderNumber,
  phone,
  purchaseDate,
  language,
}: SitejabberProps) => {
  const {
    brand: { code: brandCode },
  } = useSiteContext();

  useEffect(() => {
    if (hasSitejabberId(brandCode)) {
      const STJREventHandler = () => {
        window.STJR.setConfig({
          language,
          user: {
            first_name: name,
            // last_name: '',
            email,
            phone,
          },
          order_date: purchaseDate,
          order_id: orderNumber,
        });
      };
      document.body.addEventListener('STJR.instantFeedbackWidgetLoaded', STJREventHandler);
      return () => {
        document.body.removeEventListener('STJR.instantFeedbackWidgetLoaded', STJREventHandler);
      };
    }
    return () => {};
  }, [brandCode, email, language, name, orderNumber, phone, purchaseDate]);

  useScript(
    'sj-widget',
    hasSitejabberId(brandCode)
      ? `https://www.sitejabber.com/js/v2/${sitejabberIds[brandCode]}/widgets.js?widget-classes=stjr-instant-feedback`
      : '',
  );

  return <div className="stjr-instant-feedback" />;
};

export default Sitejabber;
